class CartActivityToast extends HTMLElement {
  constructor() {
    super();
    this._timeout = null;

    this.successTemplate = this.querySelector('[data-toast-type="success"]');
    this.errorTemplate = this.querySelector('[data-toast-type="error"]');
    this.toastElement = this.querySelector(".cart-activity-toast");
    this.messageContainer = this.querySelector(".cart-activity-toast__message");
  }

  connectedCallback() {
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      this.unsubscribeCartUpdate = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (event) => {
          // We only want to react to additions from the product form
          if (event.source === "product-form") {
            this.show(this.successTemplate.innerHTML);
          }
        }
      );

      this.unsubscribeCartError = subscribe(
        PUB_SUB_EVENTS.cartError,
        (event) => {
          if (event.source === "product-form") {
            const errorMessage =
              event.message ||
              event.description ||
              this.errorTemplate.innerHTML;
            this.show(errorMessage, { isError: true });
          }
        }
      );
    }
  }

  disconnectedCallback() {
    if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
    if (this.unsubscribeCartError) this.unsubscribeCartError();
    if (this._timeout) clearTimeout(this._timeout);
  }

  show(message = "", { timeout = 4000, isError = false } = {}) {
    if (!this.toastElement || !this.messageContainer) return;

    this.messageContainer.innerHTML = message;
    this.toastElement.classList.toggle("is-error", isError);
    this.toastElement.classList.add("is-visible");

    if (this._timeout) clearTimeout(this._timeout);
    this._timeout = setTimeout(() => this.hide(), timeout);
  }

  hide() {
    if (!this.toastElement) return;
    this.toastElement.classList.remove("is-visible");
  }
}

if (!customElements.get("cart-activity-toast")) {
  customElements.define("cart-activity-toast", CartActivityToast);
}
